// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var ThemePreference;
(function (ThemePreference) {
    ThemePreference["Light"] = "light";
    ThemePreference["Dark"] = "dark";
    ThemePreference["System"] = "system";
})(ThemePreference || (ThemePreference = {}));
export var Themes;
(function (Themes) {
    Themes["Light"] = "light";
    Themes["Dark"] = "dark";
})(Themes || (Themes = {}));
